import { Pagination as AntPagination } from 'antd';
import css from './pagination.module.scss';

export default function Pagination({ children, ...rest }: any) {
    const classList = [css.efPagination];
    const props = {
        hideOnSinglePage: true,
        ...rest,
    };
    if (rest.className) {
        classList.push(rest.className);
        props.className = classList;
    }
    return <AntPagination {...props}></AntPagination>;
}
